import axios from "axios";

// API Base URL from environment variables
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://innorisedmspreprdapi.azurewebsites.net/api";

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json" },
});

// const nav = useNavigate();
const getTokenFromLocalStorage = () => {
    return localStorage.getItem("Token");
};
const addTokenToLocalStorage = (token) => {
    localStorage.setItem("Token", token);
};
// const Logout_URL = "https://csdapiuat.castroldms.com/api/login/logout";

// const logout_payload = {UserId : localStorage.getItem("UserId")};



// const logout = async () => {
//     console.log("call logout");
//     try {
//         await axios.post(
//             Logout_URL,
//             logout_payload
//         );
//         localStorage.clear();
//         navigation.navigate("/");
//     } catch (error) {
//         console.log(error);
//     }
// };

// setTimeout(logout, 10000);

// console.log("A000",localStorage.getItem("UserId"))
// console.log("A000",logout_payload);


const payload = () => {
    const UserId = localStorage.getItem("UserId");
    const token = localStorage.getItem("Token");
    const RefreshToken = localStorage.getItem("RefreshToken");
    let obj = {
        userId: UserId,
        token: token,
        refreshToken: RefreshToken,
    };
    return obj;
};
// const auth = storage.getLocal("user");
const Axios = axios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json" },
});

export const AxiosExcel = axios.create({
    baseURL: BASE_URL,
    headers:{"Content-Type": "multipart/form-data"},
});
// debugger;
//Add a request interceptor
Axios.interceptors.request.use(
    (config) => {
        const Token = getTokenFromLocalStorage();
        //localStorage.getItem('Token');
        if (Token) {
            config.headers.Authorization = `Bearer ${Token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);
// Add a response interceptor
Axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
  
        // Handle network errors (server unreachable, downtime, etc.)
        if (error.response === undefined && error.code === "ERR_NETWORK") {
        // Redirect to login or a maintenance page
            localStorage.clear();
            window.location.href = "/"; // or "/maintenance"
            return;
        }
        if (error.response) {
        // Handle downtime status (503 Service Unavailable)
            if (error.response.status === 503) {
                // Redirect to a maintenance page
                window.location.href = "/"; // Customize this as needed
                return;
            }
  
            // If 401 and no _retry flag, try refresh
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
  
                try {
                    const obj = payload();
                    const response = await Axios.post(
                        "login/refreshToken",
                        JSON.stringify(obj)
                    );
                    //eslint-disable-next-line
                    const { Token } = response?.data?.Data;
                    // Retry the original request with the new token
                    originalRequest.headers.Authorization = `Bearer ${Token}`;
                    addTokenToLocalStorage(Token);
                    return Axios(originalRequest);
                } catch (refreshError) {
                    // If refresh token fails, redirect to login
                    localStorage.clear();
                    window.location.href = "/";
                    return;
                }
            }
        }
  
        // Other errors: just reject to let other parts of app handle it
        return Promise.reject(error);
    }
);
  
AxiosExcel.interceptors.request.use(
    (config) => {
        const Token = getTokenFromLocalStorage();
        //localStorage.getItem('Token');
        if (Token) {
            config.headers.Authorization = `Bearer ${Token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);
// Add a response interceptor
AxiosExcel.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
  
        // Handle network errors (server unreachable, downtime, etc.)
        if (error.response === undefined && error.code === "ERR_NETWORK") {
            localStorage.clear();
            window.location.href = "/"; // or "/maintenance"
            return;
        }
  
        if (error.response) {
        // Handle downtime status (503 Service Unavailable)
            if (error.response.status === 503) {
                window.location.href = "/maintenance"; // Customize this as needed
                return;
            }
  
            // If 401 and no _retry flag, try refresh
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
  
                try {
                    const obj = payload();
                    const response = await Axios.post(
                        "login/refreshToken",
                        JSON.stringify(obj)
                    );
                    //eslint-disable-next-line
                    const { Token } = response?.data?.Data;
                    // Retry the original request with the new token
                    originalRequest.headers.Authorization = `Bearer ${Token}`;
                    addTokenToLocalStorage(Token);
                    return AxiosExcel(originalRequest);
                } catch (refreshError) {
                    // If refresh token fails, redirect to login
                    localStorage.clear();
                    window.location.href = "/";
                    return;
                }
            }
        }
  
        // Other errors: just reject to let other parts of app handle it
        return Promise.reject(error);
    }
);
  
export default Axios;
